module.exports = __webpack_public_path__ + "static/media/areamap8.c397a1f9.svg";